import BaseLineup from 'services/sports/default/base-lineup';
import $ from 'jquery';
import Action from 'actions';
import Const from 'constants';
import {round} from 'helpers/number-helper';

export default class Lineup extends BaseLineup {
    setPlayersByColumns({incomingValues: {team}}) {
        const {modesConfig} = Action.getState();
        const label = modesConfig.getConfig(Const.CAPTAIN_MODE).getLabel();

        let captain = null;
        let flex = [];
        team.map((player) => {
            if (player.getIsCaptain()) {
                captain = {...player, positionInLineup: label + ' - 1.5x'};
            } else {
                flex.push({...player, positionInLineup: 'F'});
            }
        });

        return $.merge([captain], flex);
    }

    recalculateLineupsUsedPlayers({incomingValues: {lineups}}) {
        return this.exec('recalculateLineupsUsedPlayers_ShowDown', {lineups});
    }

    sumPlayersProperty({incomingValues: {players, prop}}) {
        let result = 0;
        players.map((player) => {
            result += Number(player.getCapPropValue(prop));
        });

        return result;
    }

    sumPlayersRoundedProperty({incomingValues: {players, prop, decimalPlacesCount = 0}}) {
        return players.reduce((propSum, player) => {
            const propValue = Number(player.getCapPropValue(prop));

            return propSum + round(propValue, decimalPlacesCount);
        }, 0);
    }
}
